export enum SubmissionStatusNumericEnum {
  readyForApproval = 1,
  submissionApproved,
  submissionRejected,
  submissionInProcess,
  submitted,
  registered,
  submissionFailed,
  pendingModelRegistration,
  replaced,
  haSystemError,
  invalidCredentials,
  internalSystemError,
  submissionPassed,
  hungRecord
}


